import background1 from "./background1.png";
import background2 from "./background2.png";
import background3 from "./background3.png";

const backgrounds: {[key: string]: any} = {
  background1,
  background2,
  background3
}

export default backgrounds;
